export const emptySchedoxCatalog = Object.freeze({
  organization_id: null,
  services: [],
});

export const normalizeSchedoxCatalog = (payload) => {
  const organizationId = Number(payload?.organization_id);
  const services = Array.isArray(payload?.services) ? payload.services : [];

  return {
    organization_id: Number.isInteger(organizationId) && organizationId > 0
      ? organizationId
      : null,
    services: services
      .map((service) => ({
        ...service,
        service_id: Number(service?.service_id),
        organization_id: Number(service?.organization_id),
        items: Array.isArray(service?.items)
          ? service.items
              .map((item) => ({
                ...item,
                service_item_id: Number(item?.service_item_id),
                service_id: Number(item?.service_id),
                organization_id: Number(item?.organization_id),
              }))
              .filter((item) => (
                Number.isInteger(item.service_item_id)
                && item.service_item_id > 0
                && item.service_id === Number(service?.service_id)
                && item.organization_id === organizationId
              ))
          : [],
      }))
      .filter((service) => (
        Number.isInteger(service.service_id)
        && service.service_id > 0
        && service.organization_id === organizationId
      )),
  };
};

export const findSchedoxService = (catalog, serviceId) => (
  (catalog?.services || []).find(
    (service) => Number(service.service_id) === Number(serviceId)
  ) || null
);

export const getSchedoxServiceItems = (catalog, serviceId) => (
  findSchedoxService(catalog, serviceId)?.items || []
);

export const formatSchedoxOption = (entry) => {
  const code = String(entry?.code || '').trim();
  return code ? `${entry.name} (${code})` : String(entry?.name || 'Unnamed');
};
